export default __webpack_public_path__ + "static/media/gg_arrows-exchange.bc6c0a90.svg";